function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue";
var _hoisted_1 = {
  "class": "tw-flex tw-gap-x-5px tw-items-center"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: 'Annuncio aggiunto ai preferiti'
}, null, -1 /* HOISTED */);
var _hoisted_4 = {
  "class": "tw-text-18 sm:tw-text-22 tw-font-semibold"
};
var _hoisted_5 = {
  "class": "tw-text tw-mb-20px"
};
var _hoisted_6 = {
  "class": "tw-grid tw-grid-cols-12 tw-items-center"
};
var _hoisted_7 = {
  "class": "tw-col-span-12 sm:tw-col-span-6 tw-font-semibold tw-text-16"
};
var _hoisted_8 = {
  "class": "tw-col-span-12 sm:tw-col-span-6 tw-mt-10px sm:tw-mt-0"
};
var _hoisted_9 = {
  "class": "tw-flex tw-justify-center"
};
var _hoisted_10 = ["innerHTML"];
import BaseBtModal from "../BaseBtModal.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
import { ref, defineAsyncComponent, computed, onMounted } from "vue";
import { getPlaceFromPlaceID } from "@services/geographyAPI";
//@ts-ignore
import { useLoggedUserStore } from "@store/LoggedUserStore";
//@ts-ignore
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
export default /*#__PURE__*/_defineComponent({
  __name: 'MailAlertOnFavouriteModal',
  props: {
    labels: {},
    showModal: {
      type: Boolean
    },
    placeId: {},
    formDetailInputValues: {},
    serializedResb: {},
    serializedPlace: {},
    alertIcon: {}
  },
  emits: ["alertTypeChanged", "opened", "closed", "confirmMailAlert", "openSignInModal", "openLoginModal"],
  setup: function setup(__props, _ref) {
    var _this = this;
    var __emit = _ref.emit;
    //@ts-ignore
    var successModal = defineAsyncComponent(function () {
      return import("./Status/SuccessModal.vue");
    });
    var limitModal = defineAsyncComponent(function () {
      return import("./Status/LimitModal.vue");
    });
    var unauthorizedModal = defineAsyncComponent(function () {
      return import("./Status/UnauthorizedModal.vue");
    });
    var limitSavedModal = defineAsyncComponent(function () {
      return import("./Status/LimitSavedModal.vue");
    });
    var loggedUserStore = useLoggedUserStore();
    var publicUserMenuStore = usePublicUserMenuStore();
    var props = __props;
    var emits = __emit;
    var isInstant = ref(true);
    var isLoading = ref(false);
    var alertType = ref("");
    var requestData = ref({
      title: "",
      email: "",
      privacy: false,
      dailyAlert: true
    });
    var responseCode = ref(1);
    var showErrorMessage = ref(false);
    var realEstateSearchBean = {};
    var place = ref(null);
    var labelFromWindow = computed(function () {
      return window["saveSearchData"]["labels"];
    });
    onMounted(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var placeID, _props$formDetailInpu, cityId, zoneId, provinceId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              realEstateSearchBean = JSON.parse(props.serializedResb);
              placeID = realEstateSearchBean.placeId || parseInt("".concat(props.placeId), 10);
              if (!props.serializedPlace) {
                _context.next = 6;
                break;
              }
              _context.t0 = JSON.parse(props.serializedPlace);
              _context.next = 9;
              break;
            case 6:
              _context.next = 8;
              return getPlaceFromPlaceID(placeID);
            case 8:
              _context.t0 = _context.sent;
            case 9:
              place.value = _context.t0;
              if (props.formDetailInputValues) {
                _props$formDetailInpu = props.formDetailInputValues, cityId = _props$formDetailInpu.cityId, zoneId = _props$formDetailInpu.zoneId, provinceId = _props$formDetailInpu.provinceId;
                realEstateSearchBean.cityId = cityId;
                realEstateSearchBean.zoneId = zoneId;
                realEstateSearchBean.provinceId = provinceId;
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    });
    var onOpened = function onOpened() {
      emits("opened");
    };
    var onClosed = function onClosed() {
      emits("closed");
    };
    var openSignInModal = function openSignInModal() {
      emits("openSignInModal");
    };
    var openLoginModal = function openLoginModal() {
      emits("openLoginModal");
    };
    var switchAlert = function switchAlert(v) {
      if (v === props.labels.instant) isInstant.value = true;else if (v === props.labels.daily) isInstant.value = false;
      // waiting for inactive alert?
    };
    var handleMailAlertConfirm = function handleMailAlertConfirm() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              requestData.value.privacy = true;
              requestData.value.title = labelFromWindow.value.defaultSearchTitle;
              requestData.value.email = loggedUserStore.isUserLogged ? publicUserMenuStore.email : "";
              requestData.value.dailyAlert = isInstant.value;
              isLoading.value = true;
              _context2.prev = 5;
              _context2.next = 8;
              return publicUserMenuStore.addSaveSearch({
                email: requestData.value.email,
                title: requestData.value.title,
                hourly: !requestData.value.dailyAlert,
                resb: realEstateSearchBean
              });
            case 8:
              //TODO: aggiungere track di GAEvent per mail alert save - sendMailAlertSaveGAEvent()
              window["dataLayer"].push({
                /* GA4 */
                "event_name": "mail_alert_save",
                "event_location": "".concat(window["_currentPageName"], ": Popup")
              });
              //Showing success modal!
              responseCode.value = 200;
              return _context2.abrupt("return", true);
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](5);
              console.error(_context2.t0);
              response = _context2.t0.response;
              if (response) {
                _context2.next = 20;
                break;
              }
              //Generic error
              showErrorMessage.value = true;
              return _context2.abrupt("return", false);
            case 20:
              //Showing error modal or default error message
              if (response.status === 401 || response.status === 405 || response.status === 409 || response.status === 412) responseCode.value = response.status;else
                //Generic error
                showErrorMessage.value = true;
              return _context2.abrupt("return", false);
            case 22:
              _context2.prev = 22;
              isLoading.value = false;
              return _context2.finish(22);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[5, 13, 22, 25]]);
      }));
    };
    return function (_ctx, _cache) {
      return responseCode.value === 1 ? (_openBlock(), _createBlock(BaseBtModal, {
        key: 0,
        id: "mail-alert-on-favourite-modal",
        "data-cy": "mail-alert-on-favourite-modal",
        "show-modal": _ctx.showModal,
        "custom-modal-dialog-classes": "modal-md",
        "custom-modal-header-classes": "tw-px-20px",
        "custom-modal-body-classes": "tw-py-10px tw-px-20px",
        "custom-modal-footer-classes": "tw-px-0 sm:tw-px-5px",
        "with-custom-footer": true,
        "with-close-icon": true,
        onOpened: onOpened,
        onClosed: onClosed
      }, {
        header: _withCtx(function () {
          return [_createVNode(BaseAlert, {
            "alrt-class": "tw-alert tw-alert-w-primary tw-mr-35px"
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
                src: _ctx.alertIcon,
                width: "20",
                height: "20",
                alt: "warning icon"
              }, null, 8 /* PROPS */, _hoisted_2), _hoisted_3])];
            }),
            _: 1 /* STABLE */
          })];
        }),
        body: _withCtx(function () {
          return [_createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.labels.title), 1 /* TEXT */), _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.labels.description), 1 /* TEXT */), _createCommentVNode(" TOGGLE MAIL ALERT "), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.labels.subtitle), 1 /* TEXT */), _createElementVNode("div", _hoisted_8, [_createVNode(BaseComplexToggle, {
            "class": "tw-self-center tw-mx-auto",
            type: "padded",
            mode: "mobile",
            labels: {
              leftToggle: {
                label: _ctx.labels.instant,
                checked: isInstant.value
              },
              rightToggle: {
                label: _ctx.labels.daily,
                checked: !isInstant.value
              }
            },
            "model-value": alertType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function (v) {
              return switchAlert(v);
            })
          }, null, 8 /* PROPS */, ["labels", "model-value"])])])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createVNode(BaseButton, {
            "data-cy": "mail-alert-confirm",
            "class": "tw-self-start tw-mx-0 sm:tw-mx-auto tw-w-full w-sm-auto sm:tw-max-w-[172px] tw-mt-20px sm:tw-mt-0",
            "btn-class": "tw-btn-w-primary",
            "is-loading": isLoading.value,
            onClick: handleMailAlertConfirm
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)];
            }),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["is-loading"])]), showErrorMessage.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "class": "tw-text-right tw-text-w-danger tw-mr-15px tw-my-5px",
            innerHTML: labelFromWindow.value.description
          }, null, 8 /* PROPS */, _hoisted_10)) : _createCommentVNode("v-if", true)];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show-modal"])) : responseCode.value === 200 ? (_openBlock(), _createBlock(_unref(successModal), {
        key: 1,
        "show-modal": true,
        labels: {
          title: labelFromWindow.value.successModalTitle,
          description1: labelFromWindow.value.description1,
          description2_1: labelFromWindow.value.description2_1,
          description2_2: labelFromWindow.value.description2_2,
          confirm_link: labelFromWindow.value.confirm_link,
          description_no_logged: labelFromWindow.value.description_no_logged
        },
        "is-logged": _unref(loggedUserStore).isUserLogged,
        "is-mail-confirmed": _unref(publicUserMenuStore).mailConfirmed,
        "with-close-icon": true,
        onClosed: onClosed
      }, null, 8 /* PROPS */, ["labels", "is-logged", "is-mail-confirmed"])) : responseCode.value === 412 ? (_openBlock(), _createBlock(_unref(limitModal), {
        key: 2,
        "show-modal": true,
        "with-close-icon": true,
        labels: {
          title: labelFromWindow.value.limitModalTitle,
          reached_limit: labelFromWindow.value.reached_limit,
          sign_in: labelFromWindow.value.sign_in
        },
        onClosed: onClosed,
        onOpenSigninModal: openSignInModal
      }, null, 8 /* PROPS */, ["labels"])) : responseCode.value === 401 ? (_openBlock(), _createBlock(_unref(unauthorizedModal), {
        key: 3,
        "show-modal": true,
        "with-close-icon": true,
        labels: {
          title: labelFromWindow.value.unauthorizedTitle,
          unauthorized: labelFromWindow.value.unauthorized,
          login: labelFromWindow.value.login
        },
        onClosed: onClosed,
        onOpenLoginModal: openLoginModal
      }, null, 8 /* PROPS */, ["labels"])) : responseCode.value === 405 || responseCode.value === 409 ? (_openBlock(), _createBlock(_unref(limitSavedModal), {
        key: 4,
        "show-modal": true,
        "with-close-icon": true,
        labels: {
          title: labelFromWindow.value.generic_error,
          limit_saved: responseCode.value === 405 ? labelFromWindow.value.limit_saved_not_logged : labelFromWindow.value.limit_saved_logged
        },
        onClosed: onClosed
      }, null, 8 /* PROPS */, ["labels"])) : _createCommentVNode("v-if", true);
    };
  }
});